// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';


import 'normalize.css'

import './main-config'

// 仅引入用到的图标以减小打包体积
import 'vue-awesome/icons/flag';
import Icon from 'vue-awesome/components/Icon'
Vue.component('v-icon', Icon)


Vue.config.productionTip = true

/* eslint-disable no-new */

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')